export const SEARCH_ACTION = {
    autoComplete: 'autocomplete',
    search: 'search',
    hardSearch: 'HARD_SEARCH',
};
